var _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup77(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 75,
    viewBox: "0 0 72 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.999,
    y: 23.2161,
    width: 47.9988,
    height: 51.1292,
    rx: 8,
    fill: "url(#paint0_linear_179_211)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 47.9988,
    height: 51.1292,
    rx: 8,
    fill: "url(#paint1_linear_179_211)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9998,
    y: 51.1272,
    width: 23.9994,
    height: 23.2168,
    rx: 5,
    fill: "url(#paint2_linear_179_211)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_211",
    x1: 63.1285,
    y1: 37.8244,
    x2: 28.6946,
    y2: 70.1714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3646DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#528EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_179_211",
    x1: 23.9994,
    y1: 0,
    x2: 23.9994,
    y2: 51.1292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC8DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7714E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_211",
    x1: 59.9995,
    y1: 51.1272,
    x2: 59.9995,
    y2: 74.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup77);
export default __webpack_public_path__ + "static/media/Group 77.2e28fdc41e3a399db7d0aaa5707fb92b.svg";
export { ForwardRef as ReactComponent };